/**
 * Client related pages
 */

import RouterUtils from '@/utils/router';
import ClientList from '@/views/client/ClientList.vue';
import ClientOutcome from '@/views/client/ClientOutcome.vue';
import ClientProfile from '@/views/client/ClientProfile.vue';
import ClientRecord from '@/views/client/ClientRecord.vue';
import ClientService from '@/views/client/ClientService.vue';
import NewClient from '@/views/client/NewClient.vue';

export default [
  {
    path: '/clients',
    name: 'clientList',
    component: ClientList,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'client-service',
          name: 'Client List',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'dashboard' });
      },
    ],
  },
  {
    path: '/client/new',
    name: 'newClient',
    component: NewClient,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'client-service',
          name: 'Client List',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'clientList' });
      },
    ],
  },
  {
    path: '/client/:clientId',
    component: ClientService,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkClient,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'client-service',
          name: 'Client List',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'clientList' });
      },
    ],
    props: true,
    children: [
      {
        path: '',
        redirect: { name: 'clientRecord' },
      },
      {
        path: 'profile',
        name: 'clientProfile',
        component: ClientProfile,
      },
      {
        path: 'records',
        name: 'clientRecord',
        component: ClientRecord,
      },
      {
        path: 'outcome',
        name: 'clientOutcome',
        component: ClientOutcome,
      },
    ],
  },
];
